<template>
  <div class="overtheworld">
	<b-container class="container-lg mt-top text-left prl-outside mb-5">
		<p class="global-text text-left mb-2">{{$t('globalText')}}</p>
	</b-container>
	<div class="cont">
    <b-container class="text-left">
		<b-row class="p-0">
			<b-col class="mx-auto" cols="12" md="9">
				<img src="@/assets/img/GERA_Welt.gif" class="w-100" style="margin-top:-10px;"/>
	<!--
				<div class="map-tooltip" :style="tooltipStyle" style="z-index:30;">
					{{ pointedLocation }}
				</div>
				<checkbox-svg-map :map="World" viewBox="400 50 610 566" preserveAspectRatio="none" width="1000" height="750" v-model="selectedLocations" @click="clickedOn" @mouseover="pointLocation" @mouseout="unpointLocation" @mousemove="moveOnLocation"/>
	-->
			</b-col>
		</b-row>
    </b-container>
	</div>
    <div class="big-text">{{$t('global')}}</div>
<!--
	<transition name="fade" mode="out-in">
		<div class="app-modal-background" v-if="showDetailMap" @click="showDetailMap = false">
			<div class="app-modal" :style="'width:'+selectedState.modalWidth" style="position:fixed;height:100%;top:0;left:0;">
			<div style="top:0;color:white;"><h2 class="fw800">{{selectedState.name}}</h2></div>
			<div class="app-modal-content" style="position: relative;overflow:hidden">
				<div v-for="(town,key) in selectedState.towns" :key="key" class="map-town cursorp" :style="'top:'+(town.top+correction)+'%;left:'+town.left+'%'" @click.stop="showDetails(town)">
					<div class="town-point"></div><div class="town-text" style="float:left" :style="(town.pos)?'margin-top:'+town.pos.top+';margin-left:'+town.pos.left:''">{{ town.name }}</div>
				</div>
				<img :src="selectedState.pic"/>
			</div>
			<div class="app-modal-footer">
				<div class="app-modal-buttons-left float-left">
				<slot name="buttons-left"></slot>
				</div>
				<div class="app-modal-buttons-right float-right">
				<slot name="buttons-right"></slot>
				</div>
				<div class="clearfix"></div>
			</div>
			</div>
		</div>
    </transition>
-->
  </div>
</template>

<script>
/*
import { CheckboxSvgMap } from "vue-svg-map"
import World from "@svg-maps/world"
import detPicRu from '@/assets/img/world/GERA_2020_RUS_Karte.png'
import detPicDe from '@/assets/img/world/GERA_2020_BRD_Karte.png'
import detPicAt from '@/assets/img/world/GERA_2020_AUT_Karte.png'
import detPicEs from '@/assets/img/world/GERA_2020_ESP_Karte.png'
import detPicHr from '@/assets/img/world/GERA_2020_HRV_Karte.png'
import detPicCh from '@/assets/img/world/GERA_2020_CHE_Karte.png'
import detPicGb from '@/assets/img/world/GERA_2020_ENG_Karte.png'
import detPicFr from '@/assets/img/world/GERA_2020_FRA_Karte.png'
import detPicHu from '@/assets/img/world/GERA_2020_HUN_Karte.png'
import detPicBg from '@/assets/img/world/GERA_2020_BGR_Karte.png'
import detPicBe from '@/assets/img/world/GERA_2020_BEL_Karte.png'
import detPicNl from '@/assets/img/world/GERA_2020_NED_Karte.png'
import detPicIe from '@/assets/img/world/GERA_2020_IRL_Karte.png'
*/
export default {
	name: 'overtheworld',
	components: {
//        CheckboxSvgMap
	},
	data () {
		return {
/*
			correction: -1,
			showDetailMap: false,
			World,
			selectedLocations: [],
			selectedLocations: ['ru', 'fr', 'de', 'gb', 'es', 'bg', 'at', 'be', 'nl', 'ie', 'ch', 'hr', 'hu'],
			selectedState: null,
			stateTitle: 'test',
			locationPic: null,
			pointedLocation: null,
			tooltipStyle: { display: 'none' },
			locations: [
				{ id: 'ru', name:'Russland', pic: detPicRu, modalWidth: '90%',
					towns: [
						{ name: 'Moskau', top: 41, left: 21 }
					]
				},
				{ id: 'de', name:'Deutschland', pic: detPicDe, modalWidth: '90%',
					towns: [
						{ name: 'München', top: 54, left: 48, details: 'Das ist München!' },
						{ name: 'Stuttgard', top: 49.5, left: 43 },
						{ name: 'Ludwigsburg', top: 48, left: 43 },
						{ name: 'Nürnberg', top: 46, left: 48 },
						{ name: 'Fürth', top: 45.5, left: 47, pos: { top: '-10px', left: '-10px' } },
						{ name: 'Heilderberg', top: 42, left: 41 },
						{ name: 'Wiesbaden', top: 37, left: 41, pos: { top: '-10px', left: '-10px' } },
						{ name: 'Frankfurt a. M.', top: 37.5, left: 43 },
						{ name: 'Eisenach', top: 35.5, left: 47 },
						{ name: 'Leibzig', top: 35, left: 54 },
						{ name: 'Kassel', top: 32, left: 45.5, pos: { top: '-10px', left: '-44px' } },
						{ name: 'Göttingen', top: 31.5, left: 46 },
						{ name: 'Köln', top: 31, left: 39 },
						{ name: 'Düsseldorf', top: 28.5, left: 39.2 },
						{ name: 'Duisburg', top: 27, left: 39.7 },
						{ name: 'Berlin', top: 27, left: 57 },
						{ name: 'Braunschweig', top: 25.5, left: 51 },
						{ name: 'Hamburg', top: 17.5, left: 50.5 },
						{ name: 'Rostock', top: 16.5, left: 56 },
					]
				},
				{ id: 'at', name:'Österreich', pic: detPicAt, modalWidth: '90%',
					towns: [
						{ name: 'Bregenz', top: 38, left: 26, pos: { top: '10px', left: '-10px' } },
						{ name: 'Innsbruck', top: 41, left: 37 },
						{ name: 'Kitzbühel', top: 39, left: 43 },
						{ name: 'Salzburg', top: 35, left: 46 },
						{ name: 'Lienz', top: 47.5, left: 45.5 },
						{ name: 'Velden', top: 50.5, left: 52 },
						{ name: 'Linz', top: 27, left: 54 },
						{ name: 'Graz', top: 44, left: 62 },
						{ name: 'Bad Tatzmannsdorf', top: 40, left: 66.5, pos: { top: '-10px', left: '-115px' } },
						{ name: 'Wien', top: 29, left: 67 }
					]
				},
				{ id: 'es', name:'Spanien', pic: detPicEs, modalWidth: '90%',
					towns: [
						{ name: 'Ibiza', top: 58.5, left: 62.5 },
						{ name: 'Port de Sóller', top: 55.5, left: 67 }
					]
				},
				{ id: 'hr', name:'Kroatien', pic: detPicHr, modalWidth: '90%',
					towns: [
						{ name: 'Dubrovnik', top: 62, left: 54 }
					]
				},
				{ id: 'ch', name:'Schweiz', pic: detPicCh, modalWidth: '90%',
					towns: [
						{ name: 'Zürich', top: 24, left: 51 },
						{ name: 'Bad Ragaz', top: 33, left: 56 },
						{ name: 'St Moritz', top: 42.5, left: 56 }
					]
				},
				{ id: 'gb', name:'Großbritannien', pic: detPicGb, modalWidth: '90%',
					towns: [
						{ name: 'Reading', top: 51, left: 46 }
					]
				},
				{ id: 'fr', name:'Frankreich', pic: detPicFr, modalWidth: '90%',
					towns: [
						{ name: 'Paris', top: 24, left: 52 }
					]
				},
				{ id: 'hu', name:'Ungarn', pic: detPicHu, modalWidth: '90%',
					towns: [
						{ name: 'Budapest', top: 34, left: 47 }
					]
				},
				{ id: 'bg', name:'Bulgarien', pic: detPicBg, modalWidth: '90%',
					towns: [
						{ name: 'Albena', top: 36, left: 66 }
					]
				},
				{ id: 'be', name:'Belgien', pic: detPicBe, modalWidth: '90%',
					towns: [
						{ name: 'Brüssel', top: 25, left: 49 },
						{ name: 'Louvein la Neuve', top: 35, left: 51 }
					]
				},
				{ id: 'nl', name:'Niederlande', pic: detPicNl, modalWidth: '90%',
					towns: [
						{ name: 'Amsterdam', top: 26, left: 46 }
					]
				},
				{ id: 'ie', name:'Irland', pic: detPicIe, modalWidth: '90%',
					towns: [
						{ name: 'Dublin', top: 42, left: 56.5 }
					]
				}
			]
*/
		}
	},
	methods: {
/*
		showDetails (town) {
			if (town.details){
				console.log(town.details)
			}
		},
		clickedOn (event) {
			// console.log(event.target)
			this.selectedLocations = ['ru', 'fr', 'de', 'gb', 'es', 'bg', 'at', 'be', 'nl', 'ie', 'ch', 'hr', 'hu']
			// console.log([this.getLocationId(event.target),this.getLocationName(event.target)])
			this.openLocation(this.getLocationId(event.target))
		},
*/
/*
		mouseOver (event) {
			console.log(this.getLocationId(event.target))
		},
*/
/*
		openLocation (locationId) {
		  // console.log('Location: ' + locationId)
		  let selLocation = this.locations.find(el => el.id == locationId)
		  if (selLocation) {
			this.selectedState = selLocation
  			this.showDetailMap = true
		  }
		},
		getLocationName(node) {
			return node && node.attributes.name.value
		},
		getLocationId(node) {
			return node && node.attributes.id.value
		},
		pointLocation(event) {
			let selLocation = this.locations.find(el => el.id == this.getLocationId(event.target))
			this.pointedLocation = null
			if (selLocation) {
				this.pointedLocation = selLocation.name
			}
		},
		unpointLocation(event) {
			this.pointedLocation = null
			this.tooltipStyle = { display: 'none' }
		},
		moveOnLocation(event) {
			if (this.pointedLocation){
				this.tooltipStyle = {
					display: 'block',
					top: `${event.clientY + 10}px`,
					left: `${event.clientX + 10}px`,
				}
			} else {
				this.tooltipStyle = { display: 'none' }
			}
		},
		setCorrectionRate() {
			const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)

			if (vw < 400) {
				this.correction = -2
			} else if (vw < 768) {
				this.correction = -1
			} else {
				this.correction = 0
			}
			this.$nextTick(() => {
				this.$forceUpdate()
			})
		}
*/
	},
  created () {
/*
    this.setCorrectionRate()
    window.addEventListener('resize', () => {
      this.setCorrectionRate()
	})
*/
	}
}
</script>
<style>
.svg-map {
	width: 100%;
	height: auto;
	stroke: white;
	stroke-width: 0.5;
	stroke-linecap: round;
	stroke-linejoin: round;
}
.svg-map__location {
	fill: #bbb;
	cursor: pointer;
}
.svg-map__location:focus, .svg-map__location:hover {
    fill: bbb;
	outline: 0;
}
.svg-map__location[aria-checked="true"] {
	fill: #307bad;
}
.overtheworld .cont .container {
	max-width: 100%;
}
.overtheworld .mt-top {
	margin-top: 160px !important;
}
.map-tooltip {
	position: fixed;
	width: auto;
	padding: 5px;
	border: 1px solid darkgrey;
	background-color: white;
	text-align: center;
}
.map-town {
	display: block;
	position:absolute;
	z-index:30;
	background:none;
	color:white;
	font-weight:bold;
	font-size:0.7em;
	width: auto;
	text-align: left;
}
.town-point {
	float:left;
	width:7px;
	height:7px;
	border-radius:50%;
	background-color:white;
	margin-top:5px;
	margin-right:5px;
}

@media only screen and (max-width: 768px) {
	.overtheworld .mt-top {
		margin-top: 120px !important;
	}
	.map-tooltip {
		padding: 2px;
		font-size: 0.8em;
	}
	.map-town {
		font-size:0.6em;
	}
	.town-point {
		float:left;
		width:4px;
		height:4px;
/*		margin-top:6px;
		margin-right:5px; */
	}
}
</style>
<style scoped>
  a, a:hover { text-decoration:underline; color: #212529; }

.app-modal-background {
  position: fixed;
  z-index: 99999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.6);
}
.app-modal {
  background-color: none;
  margin: 5% auto;
  border-radius: 5px;
}
.app-modal-title {
  font-weight: bold;
}
.app-modal-content {
  position: relative;
  padding: 10px 12px;
}
.app-modal-content img {
  width:100%;
  margin-top: -7%;
}
.app-modal-footer {
  padding: 10px 12px;
}
.app-modal-buttons-right button {
  margin-left: 10px;
  min-width: 60px;
  font-size: 11px;
}
.app-modal-buttons-left button {
  margin-right: 10px;
}
.app-modal-close {
  cursor: pointer;
}
@media only screen and (max-width: 1200px) {
	.town-text {
		font-size:1vw;
	}
}
@media only screen and (max-width: 768px) {
	.global-text {
		padding-top:35px !important;
	}
}
</style>
<i18n>
	{
		"de": {
			"global": "Weltweit",
			"globalText": "Unser guter Ruf als Montagetischler eilt uns nicht nur voraus, sondern bringt uns für unsere Einsätze an die spannendsten Orte der Welt."
		},
		"en": {
			"global": "Global",
			"globalText": "Our good reputation not only speaks for itself, but it brings us installation jobs in some of the most exciting places on earth."
		}
	}
</i18n>
